import {SiUtil} from "./SiUtil";
import {HttpClient} from "@angular/common/http";
import {Injector} from "@angular/core";
import {AuthService, User} from '../utility/auth-service';
import {HttpHeaders} from "@angular/common/http";
import {LazyLoadRequest} from "../request/LazyLoadRequest";
import {HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {Observable} from "rxjs/internal/Observable";
import {Subject, BehaviorSubject} from "rxjs";
import {Router} from "@angular/router";
import Decimal from "decimal.js";
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

@Injectable({
    providedIn:"root"
})

export abstract class MasterProvider{
   
    lazyCriteria: LazyLoadRequest;
    util: SiUtil;
    globalUser:User;
    public pageSize: number = 10;
    globalServerPath: string = "";
    
    route: Router;
    EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    EXCEL_EXTENSION = '.xlsx';
    
    public injectorObj = Injector.create({
        providers: [
            {provide: SiUtil, deps: []},

        ]
    });
    
    
    constructor(public injector: Injector, public http: HttpClient, public authService: AuthService) {
        this.util = this.injectorObj.get(SiUtil);
        this.globalUser = this.getSession();
        
//        window.console.log=function(){};
//        this.clearConsole();
//        console.clear();
    }

    clearConsole() {
        if (window.console || window.console) {
            console.clear();
        }
    }
    
    private message = new BehaviorSubject<any>("Initial Message"); 
    getMessage = this.message.asObservable();
    setMessage(message:any){
        this.message.next(message);
    }
    
    getSession() {
        try {
            if (this.authService.getSession()) {
                this.globalUser = this.authService.getSession();
                return this.globalUser;
            }
            else {
                console.log("Session Not Inited....");
                localStorage.removeItem('isLoggedin');
                localStorage.clear();
            }
        } catch (e) {
            console.log(e);
        }
    }
    
    
    
    
    public abstract save(obj: any);
    public abstract update(obj: any);
    public abstract findById(objId: any);
    public abstract findAll();
    public abstract deleteById(obj: any);
    public abstract defunctById(obj: any);

   getGlobalServerPath(){
       return this.globalServerPath;
   }

    getSecuredAuthToken() {
        console.log(this.globalServerPath);
        return this.http.get(this.globalServerPath + "/api/auth/token");
    }

    doHttpPost(servicePath: string, param: any, authentication?: boolean) {
        return this.http.post(this.globalServerPath + servicePath, param);
    }
    
    doHttpPutPromised(servicePath: string, param: any, authentication: boolean) {
        return new Promise((resolve, reject) => {
            this.util.toastConfirmationUpdate().then(result => {
                if (result) {
                    this.http.post(this.globalServerPath + servicePath, param).subscribe((lava: any) => {
                        this.util.toastSuccess("Record Update Successfully.");
                        resolve(result);
                    }, error => {
                        this.util.toastError("Abort Transaction.");
                        console.log(error);
                        reject(error);
                    })
                } else {
                    console.log("no Action ");
                    reject("cancel");
                }
            })
        })
    }
    
    doHttpPostPromised(servicePath: string, param: any, authentication: boolean) {
        return new Promise((resolve, reject) => {
            this.util.toastConfirmationSave().then(result => {
                if (result) {
                    this.http.post(this.globalServerPath + servicePath, param).subscribe((lava: any) => {
                        console.log(lava);
                        this.util.toastSuccess("Record Update Successfully.");
                        resolve(result);
                    }, error => {
                        this.util.toastError("Abort Transaction.");
                        console.log(error);
                        reject(error);
                    })
                } else {
                    console.log("no Action ");
                    reject("cancel");
                }
            })
        })
    }
    doHttpDeletePromised(servicePath: string, param: any, authentication: boolean) {
        return new Promise((resolve, reject) => {
            this.util.toastConfirmationDelete().then(result => {
                if (result) {
                    this.http.post(this.globalServerPath + servicePath, param).subscribe((lava: any) => {
                        this.util.toastSuccess("Record Update Successfully.");
                        resolve(result);
                    }, error => {
                        this.util.toastError("Abort Transaction.");
                        console.log(error);
                        reject(error);
                    })
                } else {
                    console.log("no Action ");
                    reject("cancel");
                }
            })
        })
    }

    doHttpGet(servicePath: string, authentication: boolean, param?: any) {
        return this.http.post(this.globalServerPath + servicePath, param)
    }
    doHttpGetNew(servicePath: string, authentication: boolean, param?: any) {
        return this.http.get(this.globalServerPath + servicePath, param)
    }
    doHttpGetLazyList(servicePath: string, authentication: boolean, pageNumber: any, pageSize: any, param?: any) {
        return this.http.post(this.globalServerPath + servicePath, param)
    }
    doHttpPostLazy(servicePath: string, authentication: boolean, param: any) {
        return this.http.post(this.globalServerPath + servicePath, param);
    }
    doHttpPostBySingleField(servicePath: string, param: any, authentication: boolean) {
        return this.http.post(this.globalServerPath + servicePath, param);
    }
  
    getStateList() {
        var stateList: any[] = [];
        return new Promise((resolve, reject) => {
            this.doHttpPost("/api/json/stateList", "101", true).subscribe((list: any) => {
                stateList = list;
                resolve(stateList);
            })
        })
    }

    getCityList(stateId: string) {
        var cityList: any[] = [];
        return new Promise((resolve, reject) => {
            this.doHttpPost("/api/json/cityList", stateId, true).subscribe((list: any) => {
                cityList = list;
                resolve(cityList);
            })
        })
    }

    doHttpPostReport(servicePath: string, param: any, authentication: boolean) {
        return this.http.post(this.globalServerPath + servicePath, param, {responseType: "arraybuffer"});
    }


    //This method only used for getting Mac Address
    //Dont use this method for calling any other list because it doesn't include any authentication
    doHttpPostMacAddress(servicePath: string, param: any, authentication: boolean) {
        return this.http.post(this.globalServerPath + servicePath, param);
    }

    // doHttpPostReportMulti(servicePath: string, param: any, authentication: boolean, reportType: string) {
    //     if (reportType != "VIEW") {
    //         return this.http.post(this.globalServerPath + servicePath, param, {responseType: "arraybuffer"})
    //     }
    //     else {
    //         return this.http.post(this.globalServerPath + servicePath, param);
    //     }
    // }
    doHttpPostReportMulti(servicePath: string, param: any, authentication: boolean, reportType: string) {
  const isFormData = param instanceof FormData;

  const options: any = {
    responseType: reportType !== 'VIEW'
      ? 'arraybuffer'
      : isFormData
        ? 'text'      // ← Needed to avoid JSON parse error for string response
        : 'json'
  };

  return this.http.post(this.globalServerPath + servicePath, param, options);
}

    doHttpPostReportMultiNew(servicePath: string, param: any, authentication: boolean, reportType: string) {
  const isFormData = param instanceof FormData;

  const options: any = {
    responseType: reportType !== 'VIEW' ? 'arraybuffer' : 'json',
  };

  if (isFormData) {
    // No need to set headers for multipart, browser will set boundary automatically
    return this.http.post(this.globalServerPath + servicePath, param, options);
  } else {
    // Fallback for JSON payload
    return this.http.post(this.globalServerPath + servicePath, param, options);
  }
}

    exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        console.log('worksheet', worksheet);
        
        const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        console.log(workbook.Sheets.data.A1);
        const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
        //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: this.EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + this.EXCEL_EXTENSION);
    }
    
    
    exportAsCsvFile(data, filename = 'data') {
        let csvData = this.convertToCSV(data, ['CLIENTID','MOBILENO','EMAIL','CLIENTNAME','CITYNAME']);
        console.log(csvData)
        let blob = new Blob(['\ufeff' + csvData], {type: 'text/csv;charset=utf-8;'});
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
            dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", filename + ".csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    convertToCSV(objArray, headerList) {
        let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
        let row = '';

        for (let index in headerList) {
            row += headerList[index] + ',';
        }
        row = row.slice(0, -1);
        str += row + '\r\n';
        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let index in headerList) {
                let head = headerList[index];

                line += array[i][head] + ',';
            }
            str += line + '\r\n';
        }
        return str;
    }
    
    
    removeDuplicates(jsonList, fieldName) {
        var newArray = [];
        var lookupObject = {};

        for (var i in jsonList) {
            lookupObject[jsonList[i][fieldName]] = jsonList[i];
        }

        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }
    
    calculateWithDecimal(a: number, operator: string, b: number): number {
        const numA = new Decimal(a);
        const numB = new Decimal(b);

        let result: Decimal;
        switch (operator) {
            case '+':
                result = numA.plus(numB);
                break;
            case '-':
                result = numA.minus(numB);
                break;
            case '*':
                result = numA.times(numB);
                break;
            case '/':
                if (numB.isZero()) {
                    throw new Error('Division by zero is not allowed.');
                }
                result = numA.dividedBy(numB);
                break;
            default:
                throw new Error('Invalid operator.');
        }

        return parseFloat(result.toFixed(2));
    }
    
}
